import { render, staticRenderFns } from "./MiddleMine.vue?vue&type=template&id=07673c5c&scoped=true&"
import script from "./MiddleMine.vue?vue&type=script&lang=js&"
export * from "./MiddleMine.vue?vue&type=script&lang=js&"
import style0 from "./MiddleMine.vue?vue&type=style&index=0&id=07673c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07673c5c",
  null
  
)

export default component.exports